import Link from "next/link";

import PropTypes from "prop-types";

import ExperimentManager from "@/experimentManager/components/ExperimentManager";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import formatHrefToSupportLegacyLink from "@/utils/formatHrefToSupportLegacyLink";
import { footerCss, listCss, atagCss, itemCss } from "./Footer.style";

const propTypes = {
  customCss: PropTypes.object,
};

const getCurrentYear = () => {
  return new Date().getFullYear();
};

export const useNavItems = () => {
  return [
    {
      path: "https://learn.newsela.com",
      label: "Help & Educator Center",
    },
    {
      path: `${MONOLITH_ORIGIN}/pages/terms-of-use/`,
      label: "Terms of Use",
    },
    {
      path: `${MONOLITH_ORIGIN}/privacy-policy/`,
      label: "Privacy Policy",
    },
    {
      path: `${MONOLITH_ORIGIN}/company/partners/`,
      label: "Partners",
    },
    {
      path: "https://support.newsela.com/article/accessibility-on-newsela/",
      label: "Accessibility",
    },
  ];
};

const Footer = ({ customCss }) => {
  const navItems = useNavItems();
  return (
    <footer css={{ ...footerCss, ...customCss }} data-qa-selector="footer">
      <ul css={listCss}>
        {navItems.map((item) => {
          return (
            <li key={item.label} css={itemCss}>
              <Link
                href={formatHrefToSupportLegacyLink(item.path)}
                passHref
                legacyBehavior
              >
                <a css={atagCss}>{item.label}</a>
              </Link>
            </li>
          );
        })}
        <li css={itemCss}>
          <span data-qa-selector="newsela_copyright">
            ©{getCurrentYear()} Newsela
          </span>
        </li>
        <li css={itemCss}>
          <ExperimentManager />
        </li>
      </ul>
    </footer>
  );
};

Footer.propTypes = propTypes;

export default Footer;
